'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'store-alt-slash';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'e070';
var svgPathData = 'M516.51,32,608,192H342.09L384,225v-1H544V351l32,25.2V224h32c24.6,0,39.91-26.5,27.71-47.91l-91.41-160A32.15,32.15,0,0,0,516.51,0h-393a31.85,31.85,0,0,0-17.92,5.76L138.91,32ZM352,478.5c0,.91-.29,1.41-.2,1.5l-255.2.2a2.23,2.23,0,0,1-.6-1.7V352H338.48l-40.64-32H96V224h79.92l-40.64-32H32.11l32-56-25.44-20L4.31,176.09C-7.89,197.5,7.42,224,32,224H64V478.5C64,497,78.31,512,96,512H352c17.71,0,32-15,32-33.5V387.86l-32-25.2ZM23,1.8A7.88,7.88,0,0,0,11.77,3l-10,12.5A7.94,7.94,0,0,0,3,26.71L617,510.23A8,8,0,0,0,628.2,509l10-12.5a7.86,7.86,0,0,0-1.21-11.2Z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faStoreAltSlash = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;